import { render } from "./BorderWidth.vue?vue&type=template&id=04c07c4e"
import script from "./BorderWidth.vue?vue&type=script&lang=ts"
export * from "./BorderWidth.vue?vue&type=script&lang=ts"
script.render = render

export default script